var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1035_1145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 28H0V0H28V28ZM2 26H26V2H2V26Z",
    fill: "#1680E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 12.5C16.7089 12.5 15.9355 12.2654 15.2777 11.8259C14.6199 11.3863 14.1073 10.7617 13.8045 10.0308C13.5018 9.29986 13.4225 8.4956 13.5769 7.71967C13.7312 6.94375 14.1122 6.23099 14.6716 5.67158C15.231 5.11217 15.9437 4.73119 16.7197 4.57685C17.4956 4.42251 18.2999 4.50176 19.0308 4.80451C19.7617 5.10726 20.3863 5.61992 20.8259 6.27772C21.2654 6.93551 21.5 7.70888 21.5 8.50001C21.5 9.56087 21.0786 10.5783 20.3284 11.3284C19.5783 12.0786 18.5609 12.5 17.5 12.5ZM17.5 6.50001C17.1044 6.50001 16.7178 6.61728 16.3889 6.83704C16.06 7.05681 15.8036 7.36917 15.6522 7.73463C15.5009 8.10008 15.4613 8.50224 15.5385 8.89021C15.6156 9.27817 15.8061 9.63449 16.0858 9.91419C16.3655 10.1939 16.7218 10.3844 17.1098 10.4616C17.4978 10.5387 17.8999 10.4992 18.2654 10.3478C18.6308 10.1964 18.9432 9.94005 19.163 9.61115C19.3827 9.28225 19.5 8.89557 19.5 8.50001C19.5 7.96957 19.2893 7.4609 18.9142 7.08582C18.5391 6.71075 18.0304 6.50001 17.5 6.50001Z",
    fill: "#1680E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 20.1399L19.69 15.8299L16.12 19.3999L8.39 11.6699L4 16.0599V23.9999H24V20.1399Z",
    fill: "#053779"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1035_1145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.8d312a5d9b2787f26f3d61f32c2a7f55.svg";
export { ForwardRef as ReactComponent };